// extracted by mini-css-extract-plugin
module.exports = {"linkList":"style_linkList__226sq"};